import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

interface FaqSection {
  heading: string;
  content: string[];
}

interface FaqPageProps {
  category: string;
  categoryPath: string;
  icon: string;
  title: string;
  intro: string;
  sections: FaqSection[];
}

export default function FaqPage({ category, categoryPath, icon, title, intro, sections }: FaqPageProps) {
  return (
    <div className="min-h-screen flex flex-col bg-white font-sans">
      <Navbar />

      {/* Page header strip */}
      <div className="bg-[#F5C518] pt-28 pb-12 px-6 sm:px-10">
        <div className="max-w-6xl mx-auto">
          {/* Breadcrumb */}
          <Link to="/" className="inline-flex items-center gap-2 text-xs font-black tracking-widest uppercase text-black/50 hover:text-black transition-colors cursor-pointer mb-6">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-left-line"></i>
            </div>
            Back
          </Link>

          <div className="flex items-center gap-4 mb-4">
            <div className="w-12 h-12 bg-black rounded-lg flex items-center justify-center">
              <i className={`${icon} text-[#F5C518] text-xl`}></i>
            </div>
            <h1 className="text-3xl sm:text-5xl font-black uppercase tracking-tight text-black leading-none">{title}</h1>
          </div>
          <div className="w-16 h-1 bg-black mt-4"></div>
        </div>
      </div>

      <main className="flex-1 max-w-6xl mx-auto w-full px-6 sm:px-10 py-16">
        <div className="max-w-3xl">
          <p className="text-black/70 text-base leading-relaxed mb-12">{intro}</p>

          <div className="space-y-10">
            {sections.map((section, i) => (
              <div key={i} className="border-t-2 border-black/10 pt-8">
                <h2 className="text-lg font-black uppercase tracking-tight text-black mb-4">{section.heading}</h2>
                <div className="space-y-3">
                  {section.content.map((para, j) => (
                    <p key={j} className="text-black/60 text-sm leading-relaxed">{para}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-16 bg-[#F5C518] p-8 sm:p-10">
            <h3 className="text-xl font-black uppercase tracking-tight text-black mb-2">Still need help?</h3>
            <p className="text-black/60 text-sm mb-6">Our support team is ready to assist you with any questions or concerns.</p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/contact-support"
                className="inline-flex items-center gap-2 px-6 py-3 bg-black text-[#F5C518] text-xs font-black tracking-widest uppercase hover:bg-black/80 transition-colors cursor-pointer whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-customer-service-2-line"></i>
                </div>
                Contact Support
              </Link>
              <Link
                to="/dispute-resolution"
                className="inline-flex items-center gap-2 px-6 py-3 border-2 border-black text-black text-xs font-black tracking-widest uppercase hover:bg-black hover:text-[#F5C518] transition-colors cursor-pointer whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-file-text-line"></i>
                </div>
                Submit a Dispute
              </Link>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
